import React from 'react'

export default (
	<svg width='47' height='47' viewBox='0 0 42 42'>
		<defs>
			<linearGradient
				id='game-a'
				x1='0%'
				x2='95.861%'
				y1='50%'
				y2='50%'
			>
				<stop offset='0%' stopColor='#ED407A' />
				<stop offset='100%' stopColor='#FB4080' />
			</linearGradient>
			<path
				id='game-b'
				d='M24,10.6666667 L8,10.6666667 C7.02222222,10.6666667 6.22222222,11.4666667 6.22222222,12.4444444 L6.22222222,19.5555556 C6.22222222,20.5333333 7.02222222,21.3333333 8,21.3333333 L24,21.3333333 C24.9777778,21.3333333 25.7777778,20.5333333 25.7777778,19.5555556 L25.7777778,12.4444444 C25.7777778,11.4666667 24.9777778,10.6666667 24,10.6666667 Z M24,19.5555556 L8,19.5555556 L8,12.4444444 L24,12.4444444 L24,19.5555556 Z M10.6666667,18.6666667 L12.4444444,18.6666667 L12.4444444,16.8888889 L14.2222222,16.8888889 L14.2222222,15.1111111 L12.4444444,15.1111111 L12.4444444,13.3333333 L10.6666667,13.3333333 L10.6666667,15.1111111 L8.88888889,15.1111111 L8.88888889,16.8888889 L10.6666667,16.8888889 L10.6666667,18.6666667 Z M18.2222222,16 C17.4858426,16 16.8888889,16.5969537 16.8888889,17.3333333 C16.8888889,18.069713 17.4858426,18.6666667 18.2222222,18.6666667 C18.9586019,18.6666667 19.5555556,18.069713 19.5555556,17.3333333 C19.5555556,16.5969537 18.9586019,16 18.2222222,16 Z M21.7777778,13.3333333 C21.0413981,13.3333333 20.4444444,13.930287 20.4444444,14.6666667 C20.4444444,15.4030463 21.0413981,16 21.7777778,16 C22.5141574,16 23.1111111,15.4030463 23.1111111,14.6666667 C23.1111111,13.930287 22.5141574,13.3333333 21.7777778,13.3333333 Z'
			/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{/* <circle
				cx='21'
				cy='21'
				r='21'
				fill='url(#game-a)'
				opacity='.35'
			/> */}
			<g transform='translate(5 5)'>
				<circle cx='16' cy='16' r='16' fill='url(#game-a)' />
				<use fill='#FFF' fillRule='nonzero' href='#game-b' />
			</g>
		</g>
	</svg>
)
